<template lang="pug">
page(
    main-title="Тарифный план и оплата",
    main-description="Обзор текущего тарифного плана"
)
    .panel.panel-white.border-none
        .panel-heading
            .panel-title(v-if="payedToDisplay")
                h4.text-danger(v-if="payments.isExpired") 
                    | Тариф истек <b>{{ payedToDisplay }}</b>. Вы можете 
                    router-link(:to="{name: 'Payment'}") оплатить
                    |  новый тарифный план.
                h4.text-warning(v-else-if="payments.isExpiringToday && !payments.recurrent") 
                    | <b>Сегодня</b> последний день текущего тарифа. Пора его 
                    router-link(:to="{name: 'Payment'}") оплатить
                    |.
                h4(v-else)
                    | Текущий тарифный план оплачен до <b>{{ payedToDisplay }}</b>
        .panel-body  
            p(v-if="payments.restriction") Ограничение тарифа – <b>{{ payments.restriction }}</b> заказов в месяц.
            template(v-if="payments.recurrent")  
                p Действует автроматическое продление тарифа. Следующее 
                    | списание средств в размере <b>{{ nextPayAmountDisplay }}</b> произойдет
                    | <b>{{ payedToDisplay }}</b>.
                button.btn.btn-default(@click="rejectAutoPayment") 
                    | Отменить автоматические платежи
            template(v-else)
                router-link.btn.btn-default(:to="{name: 'Payment'}") Оплатить


</template>

<script>
import { mapState, mapGetters } from 'vuex';

import swal from 'sweetalert';

export default {
    name: 'TariffPlan',
    created() {
        this.getTariffPlan();
    },
    mounted() {
        if (this.$cookie.get('payResult')) {
            this.showPayResult(
                this.$cookie.get('payResult'),
                this.$cookie.get('payResultMessage')
            );
            this.$cookie.delete('payResult');
            this.$cookie.delete('payResultMessage');
        }
    },
    methods: {
        getTariffPlan() {
            this.$store.dispatch('getTariffPlanState');
        },
        rejectAutoPayment() {
            this.$store.dispatch('rejectAutoPayment');
        },
        showPayResult(status, text) {
            let title, icon;
            if (status === 'success') {
                title = 'Платёж успешно совершён';
                icon = 'success';
                swal({icon, title, button: 'Окей'});
            } else if (status === 'failure') {
                title = 'Платёж не прошёл';
                icon = 'error';
                swal({
                    icon,
                    title,
                    text,
                    button: 'Окей'
                });
            }
        }
    },
    computed: {
        payments() {
            return this.$store.state.payments;
        },
        nextPayAmountDisplay() {
            let amount = this.payments.nextPayAmount;
            return amount && Number(amount).toLocaleString('ru-RU') + ' ₽';
        },
        ...mapGetters([
            'payedToDisplay'
        ])
    },
    data() {
        return {
        };
    }
};
</script>

<style>
.border-none {
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/payments/TariffPlan.vue